import * as React from 'react';
import classnames from 'classnames';

export interface IMediaLibraryItemProps {
    data: any;
    handleClick: (event: any) => void;
    selected: any;
}

const MediaLibraryItem: React.SFC<IMediaLibraryItemProps> = (props) => {
    const { data } = props;
    let isActive = false;
    // add the className if this is selected
    isActive = props.selected && props.selected.value === data.value;
    return (
        <div
            className={classnames('list-item', {
                ['active']: isActive
            })}
            onClick={props.handleClick}
        >
            <div className="list-item--image">
                {data.thumbnail.includes('mp4') ||
                data.thumbnail.includes('webm') ||
                data.thumbnail.includes('ogg') ||
                data.thumbnail.includes('mov') ||
                data.thumbnail.includes('webm') ||
                data.thumbnail.includes('avi') ||
                data.thumbnail.includes('mov') ||
                data.thumbnail.includes('wnv') ? (
                    <video controls={false} autoPlay={false}>
                        <source src={data.thumbnail} type="video/mp4" />
                    </video>
                ) : (
                    <img src={data.thumbnail} alt={data.label} />
                )}
                <span className="list-item--type">{data.type}</span>
            </div>
            <div className="list-text">
                <div className="list-title">{data.label}</div>

                <div className="list-tags">
                    {data.tags.map((t: any, index: number, { length }) => (
                        <span key={'media-item-' + index} className="tag">
                            {t.label}
                            {index + 1 === length ? '' : ','}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MediaLibraryItem;
